import React, { useState, useEffect } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DescriptionIcon from "@mui/icons-material/Description";

const SpreadsheetAlert = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const spreadsheetAlertDismissed = localStorage.getItem(
      "spreadsheetAlertDismissed"
    );
    if (!spreadsheetAlertDismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem("spreadsheetAlertDismissed", "true");
  };

  if (!isVisible) {
    return null;
  }

  return (
    <>
      {/* Desktop Version */}
      <Box
        sx={{
          display: { xs: "none", md: "block" },
          marginBottom: 3,
        }}
      >
        <Box
          sx={{
            backgroundColor: (theme) => theme.palette.primary[400],
            color: "#fff",
            borderRadius: 1,
            padding: 2,
            display: "flex",
            alignItems: "center",
            gap: 2,
            position: "relative",
          }}
        >
          <DescriptionIcon
            sx={{
              color: "#fff",
              fontSize: "2rem",
            }}
          />
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 600,
                marginBottom: 0.5,
              }}
            >
              Did you know we can ingest your Product Spreadsheet?
            </Typography>
            <Typography variant="body2">
              Send your Product Spreadsheet to contact@specapp.com, and
              we&apos;ll ingest it all for you!
            </Typography>
          </Box>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              color: "#fff",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.1)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>

      {/* Mobile Version */}
      <Box
        sx={{
          display: { xs: "block", md: "none" },
          marginBottom: 3,
          marginX: 2,
        }}
      >
        <Box
          sx={{
            backgroundColor: (theme) => theme.palette.primary[400],
            color: "#fff",
            borderRadius: 2,
            padding: 2,
          }}
        >
          {/* Top row with icon and close button */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 1,
            }}
          >
            <DescriptionIcon
              sx={{
                color: "#fff",
                fontSize: "1.5rem",
              }}
            />
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                color: "#fff",
                padding: 0.5,
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                },
              }}
            >
              <CloseIcon sx={{ fontSize: "1.1rem" }} />
            </IconButton>
          </Box>

          {/* Content */}
          <Box sx={{ marginTop: 2 }}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 600,
                fontSize: "0.95rem",
                lineHeight: 1.3,
                marginBottom: 2,
              }}
            >
              Did you know we can ingest your Product Spreadsheet?
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontSize: "0.85rem",
                lineHeight: 1.4,
                opacity: 0.95,
              }}
            >
              Send your Product Spreadsheet to contact@specapp.com, and
              we&apos;ll ingest it all for you!
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default SpreadsheetAlert;
